import React, { useState } from "react";
import cn from "classnames";
import { AnimatePresence, m } from "framer-motion";
import { heightCollapse } from "@/framework/utils/motion/height-collapse";
import ChevronDownRounded from "@/icons/chevron-down-rounded";
export const Accordion = ({
  i,
  icon,
  title,
  content,
  variant = "darkBeige",
  open,
  expanded,
  setExpanded,
  children,
}) => {
  const isOpen = i === expanded; // Determine if this accordion is open

  return (
    <div
      className={cn(
        {
          "bg-darkBeige": isOpen,
        },
        "w-full transition-all duration-200 ease hover:bg-darkBeige border-b border-dashed border-darkGrey/20"
      )}
    >
      <m.header
        initial={false}
        onClick={() => setExpanded(isOpen ? null : i)} // Close if open, else expand
        className={cn(
          "cursor-pointer flex items-center justify-between transition-colors py-5 md:py-6",
          {
            "px-2": variant === "darkBeige",
          }
        )}
      >
        <div className="flex flex-row items-center gap-4">
          {icon && icon}
          <h2
            className={cn(
              "text-sm font-semibold leading-relaxed text-heading pr-2",
              {
                "md:text-base": variant === "darkBeige",
                "md:text-base lg:text-base": variant === "transparent",
                "lg:text-base text-sm": variant === "faq",
              }
            )}
          >
            {title}
          </h2>
        </div>

        <ChevronDownRounded
          className={`text-lg text-brown ${
            isOpen ? "-rotate-180" : "rotate-0"
          } transition-all duration-500 ease transform md:w-7 w-6`}
        />
      </m.header>
      <AnimatePresence initial={false}>
        {isOpen && (
          <m.div
            key="content"
            initial="from"
            animate="to"
            exit="from"
            variants={heightCollapse()}
            className="overflow-hidden px-12"
          >
            <div
              className={cn("leading-7 text-sm text-darkGrey pb-5 [&>p]:mb-2")}
              // dangerouslySetInnerHTML={{ __html: content }}
            >
              {children}
            </div>
          </m.div>
        )}
      </AnimatePresence>
    </div>
  );
};
